export default class BusinessHour {
  public readonly closingHour: string;
  public readonly isOpen: boolean;
  public readonly openingHour: string;
  public readonly weekday: number;

  constructor(init: BusinessHourInit) {
    this.closingHour = init.closingHour;
    this.isOpen = init.isOpen;
    this.openingHour = init.openingHour;
    this.weekday = init.weekday;
  }
}

export interface BusinessHourInit {
  closingHour: string;
  isOpen: boolean;
  openingHour: string;
  weekday: number;
}
